import { faArrowDownToArc } from '@fortawesome/pro-regular-svg-icons/faArrowDownToArc'
import { faArrowUpFromArc } from '@fortawesome/pro-regular-svg-icons/faArrowUpFromArc'
import { faFlagSwallowtail } from '@fortawesome/pro-regular-svg-icons/faFlagSwallowtail'
import { Grid, Text } from '@mantine/core'

import { useAppSelector } from '@flecto-io/core'
import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import Card from '@flecto/ui/lib/ui/atoms/Card'

import { bookingSelector } from './selectors'
export default function BookingPickPanel() {
  const { t } = useTranslation('saas', { keyPrefix: 'create-booking-return' })
  const { total_reserved, total_pickup, total_returned, isLoading, show } =
    useAppSelector(bookingSelector)

  if (isLoading || !show) return null
  return (
    <Card role='status'>
      <Grid style={{ display: 'flex', alignItems: 'center' }}>
        <Grid.Col span='content'>
          <Icon
            icon={faFlagSwallowtail}
            size='sm'
            color='blue'
            withCircleBackground
          />
        </Grid.Col>
        <Grid.Col
          span={2}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text>{t('reserved_flag')}</Text>
          <Text>{total_reserved}</Text>
        </Grid.Col>
        <Grid.Col offset={1.5} span='content'>
          <Icon
            icon={faArrowUpFromArc}
            size='sm'
            color='orange'
            withCircleBackground
          />
        </Grid.Col>
        <Grid.Col
          span={2}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text>{t('pickedup_flag')}</Text>
          <Text>{total_pickup}</Text>
        </Grid.Col>
        <Grid.Col offset={1.5} span='content'>
          <Icon
            icon={faArrowDownToArc}
            size='sm'
            color='brand'
            withCircleBackground
          />
        </Grid.Col>
        <Grid.Col
          span={2}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Text>{t('returned_flag')}</Text>
          <Text>{total_returned}</Text>
        </Grid.Col>
      </Grid>
    </Card>
  )
}
